import { OnboardingOrderOutIntegration, OnboardingOrderOutIntegrationForm, OnboardingOrderOutIntegrationUpsert } from '@models/.';
import { Local } from '@core/models/local';

export function transformToData(onboardingOrderOut: OnboardingOrderOutIntegration | null): OnboardingOrderOutIntegration | null {
  if (!onboardingOrderOut) return null;
  
  return {
    ...onboardingOrderOut,
  };
}

export function transformToForm(onboardingOrderOut?: OnboardingOrderOutIntegrationForm): OnboardingOrderOutIntegrationForm | undefined {
  if (!onboardingOrderOut) return;
  
  return onboardingOrderOut;
}

import { environment } from 'src/environments/environment';

export function transformToUpsert(
    formValue: { type: string; partner: string; status: string },
    localStore: Local 
): OnboardingOrderOutIntegrationUpsert {
  return {
    oo_billing_account_id: Number(environment.oo_billing_account_id),
    account_name: localStore.cuenta?.nombre,
    restaurant_address_street: localStore.ubicacion?.mainStreet,
    restaurant_address_city: localStore.ubicacion?.ciudad,
    restaurant_address_state: localStore.ubicacion?.estado,
    restaurant_address_zipcode: localStore.ubicacion?.codigoPostal,
    restaurant_address_country: localStore.ubicacion?.pais,
    account_manager_email: localStore.cuenta?.datosContacto?.email,
    account_manager_firstname: localStore.cuenta?.nombre,
    account_manager_lastname: 'Support',
    account_manager_phone: localStore.cuenta?.datosContacto?.telefono,
    restaurant_manager_email: localStore.datosContacto?.email,
    restaurant_manager_firstname: localStore.datosContacto?.nombre,
    restaurant_manager_lastname: 'Manager',
    restaurant_manager_phone: localStore.datosContacto?.telefono,
    pos_uuid: localStore.idLocal,
    channel_uuid: '',
    cuentaId: localStore.cuenta?.idCuenta,
  };
}